<template>
  <div v-if="!isProfileLoaded" class="Dashboard__View" style="display: flex; justify-content: center; align-items: center; min-height: 400px;">
    <b-loading :is-full-page="false" :active="true" :can-cancel="false"/>
  </div>
  <div v-else-if="isProfileLoaded" class="Dashboard__View">
    <div class="Dashboard__Widgets">
      <div class="DashBoard__Widgets__Indicators">
        <div v-if="$store.state.profile.sosna" class="DashBoard__Widgets__Indicators__Item">
          <div class="DashBoard__Widgets__Indicators__Item__Box">
            <div class="amount">
              <img style="min-width: 80px;" src="../assets/Sosna.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="DashBoard__Widgets__Indicators__Item DashBoard__Widgets__Indicators__Item--clickable" @click="$router.push('/vehicles')">
          <h3>רכבים מנוהלים החודש</h3>
          <div class="DashBoard__Widgets__Indicators__Item__Box">
            <div class="amount">
              <b-icon v-if="isLoadingManagedVehicleCount" icon="loading" custom-class="mdi-spin" />
              <template v-else>{{ managedVehicleCount }}</template>
            </div>
          </div>
        </div>
        <div class="DashBoard__Widgets__Indicators__Item DashBoard__Widgets__Indicators__Item--clickable" @click="$router.push({ path: '/transfers/company', query: { tab: 'UnmanagedReports' } })">
          <h3>דוחות על רכבים לא מנוהלים</h3>
          <div class="DashBoard__Widgets__Indicators__Item__Box">
            <div class="amount">
              <b-icon v-if="isLoadingUnManagedVehicleCount" icon="loading" custom-class="mdi-spin" />
              <template v-else>{{ unManagedVehicleCount }}</template>
            </div>
          </div>
        </div>
        <template v-if="!isLeasingCompany">
          <div class="DashBoard__Widgets__Indicators__Item">
            <h3>דוחות שלא שולמו</h3>
            <div class="DashBoard__Widgets__Indicators__Item__Box">
              <div class="amount">
                <b-icon v-if="isLoadingUnpaidReportCount" icon="loading" custom-class="mdi-spin" />
                <template v-else>{{ unpaidReportCount }}</template>
              </div>
            </div>
          </div>
          <div class="DashBoard__Widgets__Indicators__Item">
            <h3>סכום לתשלום</h3>
            <div class="DashBoard__Widgets__Indicators__Item__Box">
              <div class="amount">
                <b-icon v-if="isLoadingUnpaidAmount" icon="loading" custom-class="mdi-spin" />
                <template v-else>{{ unpaidAmount | currency }}</template>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="DashBoard__Widgets__Indicators__Item DashBoard__Widgets__Indicators__Item--clickable" @click="$router.push({ path: '/transfers/company', query: { tab: 'TransfersCompanyMissingDocumentReports' } })">
            <h3>דוחות שממתינים להסבה</h3>
            <div class="DashBoard__Widgets__Indicators__Item__Box">
              <div class="amount">
                <b-icon v-if="isLoadingAwaitingTransfers" icon="loading" custom-class="mdi-spin" />
                <template v-else>{{ awaitingTransfersCount }}</template>
              </div>
            </div>
          </div>
          <div class="DashBoard__Widgets__Indicators__Item">
            <h3 v-if="startDateTooltip">
              <b-tooltip :label="startDateTooltip" type="is-dark" position="is-top">כמות דוחות שהוסבו מתחילת הפעילות</b-tooltip>
            </h3>
            <h3 v-else>כמות דוחות שהוסבו מתחילת הפעילות</h3>
            <div class="DashBoard__Widgets__Indicators__Item__Box">
              <div class="amount">
                <b-icon v-if="isLoadingTransfersPie" icon="loading" custom-class="mdi-spin" />
                <template v-else>{{ transfersCompletedCount }}</template>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="Charts">
        <div class="ml-3" v-if="!isLeasingCompany">
          <b-loading
            :is-full-page="false"
            v-model="isLoadingPie"
            :can-cancel="false"
          />
          <div v-if="!isLoadingPie && hasPiedata">
            <h1>פילוח דוחות ע"פ סטטוס לשנת {{ new Date().getFullYear() }}</h1>
            <Pie v-if="pie" :chart-data="pie" :options="pieOptions" />
          </div>
          <h1 class="no-data" v-if="!hasPiedata && !isLoadingPie">
            אין נתונים להצגה
          </h1>
        </div>
        <div class="ml-3" v-if="isLeasingCompany">
          <b-loading
            :is-full-page="false"
            v-model="isLoadingTransfersPie"
            :can-cancel="false"
          />
          <div v-if="!isLoadingTransfersPie && hasTransfersPiedata">
            <h1 class="text-center">פילוח הסבות ע"פ סטטוס מתחילת הפעילות</h1>
            <Pie v-if="transfersPie" :chart-data="transfersPie" :options="pieOptions" />
          </div>
          <h1 class="no-data" v-if="!hasTransfersPiedata && !isLoadingTransfersPie">
            אין נתונים להצגה
          </h1>
        </div>
        <div v-if="isLeasingCompany === false" class="mr-3">
          <GmapMap
            ref="googleMap"
            :center="{ lat: 31.31158, lng: 35.0421 }"
            :zoom="7"
            :options="{
              styles: styles,
            }"
            style="width: 100%; height: 100%"
          >
            <gmap-info-window
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <div>
                <div class="info-window" v-if="marker && !markerIsLoading">
                  <ul>
                    <li>
                      <label>לוחית רישוי: </label>'{{ marker.Vehicle.Name }}
                    </li>
                    <li>
                      <label>כתובת: </label> {{ marker.Address }},
                      {{ marker.Municipality.Name }}
                    </li>
                    <li>
                      <label>נלקח בתאריך: </label
                      ><span class="ltr inline-block"></span>
                    </li>
                    <li>
                      <label>סכום לתשלום: </label>{{ marker.CurrentAmount }}
                    </li>
                    <li><label>סיבה: </label>{{ marker.Reason || "אין" }}</li>
                    <li><label>סטטוס: </label>{{ marker.Status.Name }}</li>
                    <div class="buttons">
                      <b-button
                        @click="watchReport(marker.Id)"
                        type="is-primary"
                        >הצג דוח</b-button
                      >
                      <b-button
                        @click="
                          showStreet(marker.AddressLat, marker.AddressLon)
                        "
                        type="is-primary"
                        >הצג רחוב</b-button
                      >
                    </div>
                  </ul>
                </div>
                <div v-if="markerIsLoading">טוען...</div>
              </div>
            </gmap-info-window>
            <gmap-heatmap-layer
              :data="heatMarks"
              :options="{ maxIntensity: 100, dissipating: true }"
            />
            <gmap-marker
              :key="m.Id"
              v-for="(m, i) in markers"
              :position="m.position"
              :visible="m.visible"
              :clickable="true"
              :draggable="false"
              @click="toggleInfoWindow(m, i)"
            ></gmap-marker>
          </GmapMap>
        </div>
        <div v-else class="mr-3 top-companies-chart-container">
          <b-loading
            :is-full-page="false"
            v-model="isLoadingTopCompanies"
            :can-cancel="false"
          />
          <div v-if="!isLoadingTopCompanies && hasTopCompaniesData" class="chart-content">
            <h1 class="chart-title">עשרת הלקוחות המובילים בהסבות</h1>
            <div class="bar-chart-wrapper">
              <Bar v-if="topCompaniesBarChart" :chart-data="topCompaniesBarChart.data" :options="topCompaniesBarChart.options" />
            </div>
          </div>
          <h1 class="no-data" v-if="!hasTopCompaniesData && !isLoadingTopCompanies">
            אין נתונים להצגה
          </h1>
        </div>
      </div>
      <div v-if="!isLeasingCompany" class="Line-Chart">
        <b-loading
          :is-full-page="false"
          v-model="isLoadingLine"
          :can-cancel="false"
        />
        <div v-if="!isLoadingLine">
          <LineChart
            :height="60"
            v-if="lineChart"
            :chart-data="lineChart.data"
            :options="lineChart.options"
          />
        </div>
      </div>
      <div v-else-if="isLeasingCompany" class="Line-Chart">
        <b-loading
          :is-full-page="false"
          v-model="isLoadingLineLeasingCompany"
          :can-cancel="false"
        />
        <div v-if="!isLoadingLineLeasingCompany && hasLineChartLeasingCompanyData">
          <LineChart :height="60" :chart-data="lineChartLeasingCompany.data" :options="lineChartLeasingCompany.options" v-if="lineChartLeasingCompany" />
        </div>
        <h1 class="no-data" v-if="!hasLineChartLeasingCompanyData && !isLoadingLineLeasingCompany">
          אין נתונים להצגה
        </h1>
      </div>
    </div>
  </div>
</template>
<script>
import Pie from "@/components/Charts/Pie.vue";
import LineChart from "@/components/Charts/Line.vue";
import Bar from "@/components/Charts/Bar.vue";
import { gmapApi } from "gmap-vue";
import ReportService from "@/services/ReportService";
import StatisticsService from "@/services/StatisticsService";
// import moment from 'moment';
import axios from "axios";
import { mapGetters } from "vuex";

const cancellations = [];
const START_DATE_TOOLTIP_PREFIX = "מתאריך";

export default {
  name: "Dashboard",
  computed: {
    google: gmapApi,
    hasPiedata() {
      return this.pie?.data?.length > 0 && this.pie.data.reduce((a, b) => a + b, 0);
    },
    hasTransfersPiedata() {
      return this.transfersPie && this.transfersPie.data.length > 0;
    },
    transfersCompletedCount() {
      const pie = this.$store.state.dashboard.transfersPieData;
      if (!pie) return "-";
      const completed = pie.find((item) => item.DisplayStatus === "ההסבה הושלמה");
      return completed ? completed.Count : 0;
    },
    startDateTooltip() {
      const startDate = this.$store.state.profile.Settings?.StartDate;
      if (!startDate) return null;
      return `${START_DATE_TOOLTIP_PREFIX} ${this.$options.filters.date(startDate)}`;
    },
    isLeasingCompany() {
      // Return false as default if profile not loaded yet
      // Vue's reactivity will automatically update when profile loads
      return this.$store.state.profile?.IsLeasingCompany ?? false;
    },
    isProfileLoaded() {
      // Check if profile has been loaded from server
      // Using Id instead of IsLeasingCompany - more reliable when switching profiles
      return this.$store.state.profile?.Id !== undefined &&
             this.$store.state.profile?.Id !== null;
    },
    hasLineChartLeasingCompanyData() {
      return this.lineChartLeasingCompany && this.lineChartLeasingCompany.data && this.lineChartLeasingCompany.data.datasets.length > 0;
    },
    hasTopCompaniesData() {
      return this.topCompaniesBarChart && this.topCompaniesBarChart.data && this.topCompaniesBarChart.data.datasets.length > 0;
    },
    ...mapGetters("dashboard", ["mapData", "lineChartData", "getPieData", "lineChartDataLeasingCompany", "getTransfersPieData", "getTopCompaniesData"]),
  },
  data() {
    return {
      mapInstance: null,
      marker: null,
      markerIsLoading: false,
      infoWindowPos: null,
      currentMidx: null,
      infoOptions: {
        content: "",
        // optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      infoWinOpen: false,
      isLoadingLine: false,
      isLoadingLineLeasingCompany: false,
      isLoadingPie: false,
      isLoadingTransfersPie: false,
      isLoadingTopCompanies: false,
      styles: [
        {
          featureType: "landscape.natural",
          elementType: "geometry.fill",
          stylers: [{ visibility: "on" }, { color: "#e0efef" }],
        },
        {
          featureType: "poi",
          elementType: "geometry.fill",
          stylers: [
            { visibility: "on" },
            { hue: "#1900ff" },
            { color: "#c0e8e8" },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ lightness: 100 }, { visibility: "simplified" }],
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [{ visibility: "on" }],
        },
        {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [{ visibility: "on" }, { lightness: 700 }],
        },
        {
          featureType: "water",
          elementType: "all",
          stylers: [{ color: "#7dcdcd" }],
        },
      ],
      pie: null,
      transfersPie: null,
      lineChart: null,
      lineChartLeasingCompany: null,
      topCompaniesBarChart: null,
      markers: [],
      heatMarks: [],
      managedVehicleCount: "-",
      unManagedVehicleCount: "-",
      averagePerVehicle: "-",
      unpaidReportCount: "-",
      unpaidAmount: "-",
      awaitingTransfersCount: "-",
      isLoadingAwaitingTransfers: false,
      isLoadingManagedVehicleCount: false,
      isLoadingUnManagedVehicleCount: false,
      isLoadingUnpaidReportCount: false,
      isLoadingUnpaidAmount: false,
      pieOptions: {
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const value = dataset.data[tooltipItem.index];
              const label = data.labels[tooltipItem.index];
              const total = dataset.data.reduce((a, b) => a + b, 0);
              const percent = total ? ((value / total) * 100).toFixed(1) : 0;
              return `${label}: ${value} (${percent}%)`;
            },
          },
        },
      },
    };
  },
  components: {
    Pie,
    LineChart,
    Bar,
  },
  async created() {
    await this.$store.dispatch("dashboard/loadStorage");
    // Vue's reactivity will handle the rest automatically via the watch below
  },
  watch: {
    // Vue-native way: Watch for profile to be loaded, then initialize
    isProfileLoaded: {
      handler(isLoaded) {
        if (isLoaded) {
          this.initializeDashboard();
        }
      },
      immediate: true // Run immediately on component creation
    }
  },
  mounted() {
  if (this.$store.state.profile && !this.isLeasingCompany && this.$refs.googleMap) {
    const self = this;
    this.$refs.googleMap.$mapPromise.then((map) => {
      this.mapInstance = map;
      this.getReports();
      map.addListener("zoom_changed", () => {
        const zoom = map.getZoom();
        if (zoom >= 12) {
          for (let i = 0; i < self.markers.length; i += 1) {
            self.markers[i].setVisible(true);
          }
        } else if (zoom < 12) {
          for (let i = 0; i < self.markers.length; i += 1) {
            self.markers[i].setVisible(false);
          }
        }
      });
    });
  }
  },
  methods: {
    initializeDashboard() {
      this.getManagedVehicleCount();
      this.getUnManagedVehicleCount();
      // this.getAveragePerVehicle();
      if (this.isLeasingCompany) {
        this.getAwaitingTransfers();
        this.getLineChartLeasingCompany();
        this.getTransfersPie();
        this.getTopCompaniesBarChart();
      } else {
        this.getUnpaidReportCount();
        this.getUnpaidAmount();
        this.getPie();
        this.getLineChart();
      }
    },
    showStreet(lat, lng) {
      const panorama = this.mapInstance.getStreetView();
      panorama.setPosition({ lat, lng });
      panorama.setPov({
        heading: 265,
        pitch: 0,
      });
      panorama.setVisible(true);
    },
    watchReport(reportId) {
      this.$router.push({ path: `/reports/${reportId}` });
    },
    toggleInfoWindow(marker, index) {
      this.marker = null;
      this.markerIsLoading = true;
      this.infoWindowPos = marker.position;
      if (this.currentMidx === index) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = index;
      }
      ReportService.getReport(marker.customData.Id)
        .then((res) => {
          const { data } = res;
          this.marker = data;
        })
        .finally(() => {
          this.markerIsLoading = false;
        });
    },
    async getLineChart() {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      cancellations.push(source);
      this.isLoadingLine = true;

      if (this.lineChartData === null) {
        await this.$store.dispatch("dashboard/getLineChartData");
      }
      const data = this.lineChartData;
      this.isLoadingLine = false;
      // Guard against null/undefined/empty data
      if (!data || !Array.isArray(data) || data.length < 2) {
        this.lineChart = null;
        return;
      }
      this.lineChart = {
        data: {
          labels: [
            "ינואר",
            "פברואר",
            "מרץ",
            "אפריל",
            "מאי",
            "יוני",
            "יולי",
            "אוגוסט",
            "ספטמבר",
            "אוקטובר",
            "נובמבר",
            "דצמבר",
          ],
          datasets: [
                {
                  label: `כמות דוחות לשנת ${data[0].Year}`,
                  backgroundColor: "#7dcdcdc7",
                  data: data[0].Months.map((item) => item.Count),
                },
                {
                  label: `כמות דוחות לשנת ${data[1].Year}`,
                  backgroundColor: "#193441",
                  data: data[1].Months.map((item) => item.Count),
                },
              ],
        },
        options: {
          layout: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
          tooltips: {
            enabled: true,
            intersect: "nearest",
            position: "nearest",
            titleFontSize: 16,
            titleMarginBottom: 10,
            titleSpacing: 10,
            bodyFontSize: 16,
            bodySpacing: 8,
            xPadding: 10,
            yPadding: 10,
            callbacks: {
              label(tooltipItem, theData) {
                let label =
                  theData.datasets[tooltipItem.datasetIndex].label || "";

                if (label) {
                  label += ": ";
                }
                label += tooltipItem.yLabel;

                label += " (";
                const calc =
                  data[tooltipItem.datasetIndex].Months[tooltipItem.index]
                    .Amount * 100;
                label += Math.round(calc) / 100;
                label += " שח)";

                return label;
              },
            },
          },
          legend: {
            display: true,
            labels: {
              fontColor: "black",
              fontSize: 17,
            },
            position: "top",
          },
          scales: {
            display: false,
            showLines: false,
            padding: 0,
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  fontColor: "#000",
                  fontSize: 15,
                },
              },
            ],
            yAxes: [
              {
                id: "y-axis-1",
                type: "linear",
                position: "left",
                gridLines: {
                  display: false,
                },
                ticks: {
                  fontColor: "#000",
                  fontSize: 15,
                },
              },
            ],
          },
        },
      };
    },
  async getLineChartLeasingCompany() {
    const { CancelToken } = axios;
    const source = CancelToken.source();
    cancellations.push(source);
    this.isLoadingLineLeasingCompany = true;
    if (this.lineChartDataLeasingCompany === null) {
      await this.$store.dispatch("dashboard/getLineChartDataLeasingCompany");
    }
    const data = this.lineChartDataLeasingCompany;
    this.isLoadingLineLeasingCompany = false;
    // Helper function to transform sparse month data to full 12 months array
    const transformMonthsData = (monthsArray) => {
      // Create array with 12 zeros (for all months)
      const fullYearData = new Array(12).fill(0);
      // Fill in the actual data for months that exist
      monthsArray.forEach((monthData) => {
        const monthIndex = monthData.Month - 1; // Month is 1-based, array is 0-based
        fullYearData[monthIndex] = monthData.TransfersCount;
      });
      return fullYearData;
    };
    this.lineChartLeasingCompany = {
      data: {
        labels: [
          "ינואר",
          "פברואר",
          "מרץ",
          "אפריל",
          "מאי",
          "יוני",
          "יולי",
          "אוגוסט",
          "ספטמבר",
          "אוקטובר",
          "נובמבר",
          "דצמבר",
        ],
        datasets: data.length
          ? [
              {
                label: `כמות הסבות לשנת ${data[0].Year}`,
                backgroundColor: "#7dcdcdc7",
                data: transformMonthsData(data[0].Months),
              },
              {
                  label: `כמות הסבות לשנת ${data[1].Year}`,
                backgroundColor: "#193441",
                data: transformMonthsData(data[1].Months),
              },
            ]
          : [],
      },
      options: {
        layout: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
        tooltips: {
          enabled: true,
          intersect: "nearest",
          position: "nearest",
          titleFontSize: 16,
          titleMarginBottom: 10,
          titleSpacing: 10,
          bodyFontSize: 16,
          bodySpacing: 8,
          xPadding: 10,
          yPadding: 10,
          callbacks: {
            label(tooltipItem, theData) {
              let label =
                theData.datasets[tooltipItem.datasetIndex].label || "";

              if (label) {
                label += ": ";
              }
              // Get the actual month data from the original sparse array
              const yearData = data[tooltipItem.datasetIndex];
              const monthNumber = tooltipItem.index + 1; // Convert back to 1-based month
              const monthData = yearData.Months.find((m) => m.Month === monthNumber);
              if (monthData) {
                label += ` ${monthData.TransfersCount} `;
              }
              return label;
            },
          },
        },
        legend: {
          display: true,
          labels: {
            fontColor: "black",
            fontSize: 17,
          },
          position: "top",
        },
        scales: {
          display: false,
          showLines: false,
          padding: 0,
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                fontColor: "#000",
                fontSize: 15,
              },
            },
          ],
          yAxes: [
            {
              id: "y-axis-1",
              type: "linear",
              position: "left",
              gridLines: {
                display: false,
              },
              ticks: {
                fontColor: "#000",
                fontSize: 15,
                beginAtZero: true,
                precision: 0,
              },
            },
          ],
        },
      },
    };
},
    colorForLabel(label) {
      const map = {
        // Transfer DisplayStatus values (from TransferStatuses table)
        "ההסבה הושלמה": "#5bc18e",
        "ממתין לטיפול הלקוח": "#FFC04C",
        "הועבר לטיפול העירייה": "#7DCDCD",
        "הסבה נשלחה לעיריה": "#7DCDCD",
        "הסבה ידנית ע\"י לקוח": "#7dd3a3",
        "ממתין לחתימת נהג": "#f5a3c7",
        "ממתין לחתימת קצין רכב": "#f5a3c7",
        "נחתם בהצלחה ע\"י נהג": "#4a90c2",
        "נחתם בהצלחה ע\"י קצין רכב": "#4a90c2",
        // Report Status.Name values
        שולם: "#5bc18e",
        פתוח: "#FFC04C",
        "כפל קנס": "#e67c7c",
        בגביה: "#9b8cff",
        "הוגש ערעור": "#7DCDCD",
      };
      return map[label] || "#bdbdbd";
    },
    async getPie() {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      cancellations.push(source);
      this.isLoadingPie = true;
      if (this.getPieData === null) {
        await this.$store.dispatch("dashboard/getPieData");
      }
      const data = [...this.getPieData].sort((a, b) => a.Status.Name.localeCompare(b.Status.Name, "he"));
      this.isLoadingPie = false;
      const labels = data.map((item) => item.Status.Name);
      this.pie = {
        labels,
        datasets: [
          {
            backgroundColor: labels.map((l) => this.colorForLabel(l)),
            data: data.map((item) => item.ReportCount),
          },
        ],
        data: data.map((item) => item.ReportCount),
      };
    },
    async getTransfersPie() {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      cancellations.push(source);
      this.isLoadingTransfersPie = true;
      if (this.getTransfersPieData === null) {
        await this.$store.dispatch("dashboard/getTransfersPieData");
      }
      const data = [...this.getTransfersPieData].sort((a, b) => a.DisplayStatus.localeCompare(b.DisplayStatus, "he"));
      this.isLoadingTransfersPie = false;
      const labels = data.map((item) => item.DisplayStatus);
      this.transfersPie = {
        labels,
        datasets: [
          {
            backgroundColor: labels.map((l) => this.colorForLabel(l)),
            data: data.map((item) => item.Count),
          },
        ],
        data: data.map((item) => item.Count),
      };
    },
    async getTopCompaniesBarChart() {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      cancellations.push(source);
      this.isLoadingTopCompanies = true;
      if (this.getTopCompaniesData === null) {
        await this.$store.dispatch("dashboard/getTopCompaniesData");
      }
      const data = this.getTopCompaniesData;
      this.isLoadingTopCompanies = false;
      if (!data || data.length === 0) {
        this.topCompaniesBarChart = null;
        return;
      }

      // Create gradient colors for each bar
      const colors = [
        '#193441'
      ];
      this.topCompaniesBarChart = {
        data: {
          labels: data.map((item) => item.CompanyName),
          datasets: [
            {
              label: "כמות הסבות",
              backgroundColor: data.map((item, index) => colors[index % colors.length]),
              borderColor: "#193441",
              borderWidth: 0,
              hoverBackgroundColor: data.map((item, index) => `${colors[index % colors.length]}dd`),
              hoverBorderColor: "#0d1a20",
              hoverBorderWidth: 1,
              data: data.map((item) => item.TransferredReportsCount),
              barThickness: 35,
              minBarLength: 30,
            },
          ],
        },
        options: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
              right: 20,
              bottom: 20,
              left: 10,
            },
          },
          tooltips: {
            enabled: true,
            mode: 'index',
            intersect: false,
            titleFontSize: 16,
            bodyFontSize: 14,
            bodySpacing: 8,
            xPadding: 15,
            yPadding: 15,
            cornerRadius: 8,
            displayColors: true,
            borderColor: '#7DCDCD',
            borderWidth: 1,
            callbacks: {
              title(tooltipItems) {
                const { index } = tooltipItems[0];
                return data[index].CompanyName;
              },
              label(tooltipItem) {
                return `כמות הסבות: ${tooltipItem.value}`;
              },
            },
          },
          legend: {
            display: true,
            labels: {
              fontColor: "#193441",
              fontSize: 16,
            },
            position: "top",
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: true,
                  color: "rgba(0, 0, 0, 0.08)",
                  lineWidth: 1,
                  drawBorder: true,
                  borderDash: [5, 5],
                },
                ticks: {
                  fontColor: "#193441",
                  fontSize: 12,
                  beginAtZero: true,
                  padding: 10,
                  precision: 0,
                  min: 0,
                  max: Math.max(...data.map((item) => item.TransferredReportsCount)),
                  autoSkip: false,
                  maxTicksLimit: 10,
                  callback(value) {
                    if (value >= 1000) {
                      return `${(value / 1000).toFixed(1)}K`;
                    }
                    return value;
                  },
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  drawBorder: true,
                },
                ticks: {
                  display: true,
                  fontColor: "#193441",
                  fontSize: 15,
                  fontStyle: '400',
                  padding: 10,
                  beginAtZero: true,
                  precision: 0,
                },
              },
            ],
          },
        },
      };
    },
    async getManagedVehicleCount() {
      this.isLoadingManagedVehicleCount = true;
      try {
        this.managedVehicleCount = await this.$store.dispatch("dashboard/getManagedVehicleCount");
      } finally {
        this.isLoadingManagedVehicleCount = false;
      }
    },
    async getUnManagedVehicleCount() {
      this.isLoadingUnManagedVehicleCount = true;
      try {
        this.unManagedVehicleCount = await this.$store.dispatch("dashboard/getUnManagedVehicleCount");
      } finally {
        this.isLoadingUnManagedVehicleCount = false;
      }
    },
    async getAveragePerVehicle() {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      cancellations.push(source);

      const { data } = await StatisticsService.averagePerVehicle(source.token);
      this.averagePerVehicle = parseInt(data.AverageCount, 10);
    },
    async getUnpaidReportCount() {
      this.isLoadingUnpaidReportCount = true;
      try {
        this.unpaidReportCount = await this.$store.dispatch("dashboard/getUnpaidReportCount");
      } finally {
        this.isLoadingUnpaidReportCount = false;
      }
    },
    async getUnpaidAmount() {
      this.isLoadingUnpaidAmount = true;
      try {
        this.unpaidAmount = await this.$store.dispatch("dashboard/getUnpaidAmount");
      } finally {
        this.isLoadingUnpaidAmount = false;
      }
    },
    async getAwaitingTransfers() {
      this.isLoadingAwaitingTransfers = true;
      try {
        this.awaitingTransfersCount = await this.$store.dispatch("dashboard/getAwaitingTransfersCount");
      } finally {
        this.isLoadingAwaitingTransfers = false;
      }
    },
    async getReports() {
      if (this.mapData === null) {
        await this.$store.dispatch("dashboard/getMapData");
      }
      const data = this.mapData;
      const bounds = new this.google.maps.LatLngBounds();
      this.heatMarks = data
        .map((item) => {
          if (item.AddressLat && item.AddressLon) {
            const marker = this.createMarker(item);
            this.markers.push(marker);

            // extend the bounds to include each marker's position
            bounds.extend(marker.position);

            return new this.google.maps.LatLng(
              item.AddressLat,
              item.AddressLon
            );
          }
          return null;
        })
        .filter((i) => i);

      this.$refs.googleMap.fitBounds(bounds);
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    createMarker(item) {
      let icon;
      switch (item.Status) {
        case "כפל קנס":
          icon =
            "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|E67C7C";
          break;
        case "שולם":
          icon =
            "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|5BC18E";
          break;
        case "פתוח":
          icon =
            "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|FFC04C";
          break;
        default:
          break;
      }
      const marker = new this.google.maps.Marker({
        position: new this.google.maps.LatLng(item.AddressLat, item.AddressLon),
        map: this.mapInstance,
        visible: false,
        opacity: 1,
        icon,
        customData: item,
      });

      return marker;
    },
  },
  destroyed() {
    console.log("destroyed");
    cancellations.forEach((i) => i.cancel());
  },
};
</script>
<style scoped lang="scss">
.Dashboard__View {
  display: flex;
  height: 100%;
  flex-direction: column;
  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    height: 100%;
    font-size: 22px;
  }
  h3{
    text-align: center;
  }
}
.DashBoard__Widgets__Indicators {
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  h3 {
    font-size: 23px;
  }
  .DashBoard__Widgets__Indicators__Item {
    width: 100%;
    border: 1px solid #2e3f506b;
    margin: 10px;
    height: 141.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;
    &--clickable {
      cursor: pointer;
      &:hover {
        border-color: #7dcdcd;
        background-color: #f5fcfc;
      }
    }
  }
  .DashBoard__Widgets__Indicators__Item__Box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
    direction: ltr;
    font-size: 30px;

    .amount {
      font-size: 30px;
      text-align: center;
      display: block;
      width: 100%;
    }

    ::v-deep .icon i.mdi::before {
      font-size: 40px;
    }
  }
}
.Charts {
  display: flex;
  padding: 15px;
  position: relative;
  z-index: 1;

  & > div {
    height: 400px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    border-radius: 3px;
    position: relative;
  }
}
.Line-Chart {
  height: calc(100vh - 510px - 200px);
  z-index: 2;
  width: 100%;
  position: relative;
}
::v-deep .info-window {
  padding: 10px;
  font-size: 17px;

  .buttons {
    display: flex;
    justify-content: center;
    padding-top: 10px;

    & > button {
      margin: 0 5px;
    }
  }
}
.text-center {
  text-align: center;
  font-weight: bold;
}
.top-companies-chart-container {
  border-radius: 12px;
  padding: 20px;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .chart-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;

    .chart-title {
      font-weight: bold;
      color: #193441;
      margin-bottom: 2px;
      text-align: center;
    }

    .bar-chart-wrapper {
      flex: 1;
      height: calc(100% - 80px);
      min-height: 450px;
      width: 100%;
      padding: 10px;
      background: white;
      border-radius: 8px;
      box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.05);
    }
  }
}
</style>
